import { useEffect, useState } from "react";

function isAttended(): boolean {
  if (typeof document === "undefined") return true;
  return document.visibilityState === "visible" && document.hasFocus();
}

/**
 * True while the user can actually be looking at this tab: it is the visible
 * tab of a non-minimised window AND that window has focus. An open room must
 * not mark messages read otherwise — a GG tab left in the background (another
 * ELGW tab in front, browser minimised, another app focused) used to swallow
 * incoming messages as "read".
 */
export function usePageAttention(): boolean {
  const [attended, setAttended] = useState(isAttended);

  useEffect(() => {
    const update = () => setAttended(isAttended());
    document.addEventListener("visibilitychange", update);
    window.addEventListener("focus", update);
    window.addEventListener("blur", update);
    update();
    return () => {
      document.removeEventListener("visibilitychange", update);
      window.removeEventListener("focus", update);
      window.removeEventListener("blur", update);
    };
  }, []);

  return attended;
}
